import React from 'react'
import Svg from './..'

export interface WandProps extends React.SVGProps<SVGSVGElement> {
  children: React.ReactNode
}

const Wand = ({ className, ...restProps }: WandProps) => {
  return (
    <Svg
      viewBox='0 0 77 59'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...restProps}
    >
      <ellipse
        cx='50.5'
        cy='30.5'
        rx='26.5'
        ry='26.5'
        transform='rotate(-180 50.5 30.5)'
        fill='#EB4F92'
      />
      <ellipse
        opacity='0.3'
        cx='28'
        cy='43'
        rx='16'
        ry='16'
        transform='rotate(-180 28 43)'
        fill='#EB4F92'
      />
      <ellipse
        opacity='0.12'
        cx='21.5'
        cy='16.5'
        rx='16.5'
        ry='16.5'
        transform='rotate(-180 21.5 16.5)'
        fill='#EB4F92'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M46.2048 18.264C46.2048 17.7481 46.0344 17.3174 45.6889 16.9719L40.0044 11.2921C39.6589 10.9466 39.2282 10.7762 38.7123 10.7762C38.1964 10.7762 37.7657 10.9514 37.4201 11.2921L0.515911 48.1964C0.170393 48.5419 0 48.9726 0 49.4885C0 50.0044 0.170393 50.4351 0.515911 50.7759L6.2004 56.4652C6.54592 56.8107 6.97664 56.9811 7.49255 56.9811C8.00846 56.9811 8.43917 56.8107 8.78469 56.4652L45.6937 19.5562C46.0344 19.2107 46.2048 18.7847 46.2048 18.264ZM33.378 26.6748L30.3062 23.603L38.717 15.1922L41.7888 18.264L33.378 26.6748ZM6.57432 17.3458L7.43575 14.5343L10.2472 13.6729L7.43575 12.8115L6.57432 10L5.71289 12.8115L2.90141 13.6729L5.71289 14.5343L6.57432 17.3458ZM14.0337 20.9051L15.7566 26.5281L17.4795 20.9051L23.1024 19.1823L17.4795 17.4594L15.7566 11.8365L14.0337 17.4594L8.41078 19.1823L14.0337 20.9051ZM44.1649 31.1808L43.3082 28.3693L42.4467 31.1808L39.6352 32.0422L42.4467 32.9036L43.3082 35.7151L44.1696 32.9036L46.9811 32.0422L44.1649 31.1808ZM24.9389 17.3458L25.8003 14.5343L28.6118 13.6729L25.8003 12.8115L24.9389 10L24.0774 12.8115L21.2612 13.6729L24.0774 14.5343L24.9389 17.3458Z'
        fill='#F5DFE8'
      />
    </Svg>
  )
}

export default Wand
